import React from 'react';
import {
  Box,
  Stack,
  Typography,
  Button,
  TextField
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

function ReviewSearchForm({
  changeConfigurationValue,
  currentConfiguration,
  handleSearch,
  numberOfMatches,
  isRequestInProgress
}) {
  return (
    <Box>
      <Stack spacing={1}>
        <Typography variant="h5">Review Search</Typography>

        <TextField
          variant="outlined"
          label="Patient Name"
          onChange={e => changeConfigurationValue('patientName', e.target.value)}
          value={currentConfiguration.patientName}
        />

        <TextField
          variant="outlined"
          label="MRN"
          onChange={e => changeConfigurationValue('mrn', e.target.value)}
          value={currentConfiguration.mrn}
        />

        <Button
          disabled={isRequestInProgress}
          variant="contained"
          disableElevation
          startIcon={<SearchIcon />}
          onClick={() => {
            handleSearch(currentConfiguration);
          }}
        >
          Search for Reviews
        </Button>

        <div>
          <Typography variant="h5">Search Results</Typography>
          {
            numberOfMatches === null
              ? (
                <Typography>
                  No searches performed yet
                </Typography>
              )
              : (
                <Typography>
                  {numberOfMatches} match(es) from last search
                </Typography>
              )
          }
        </div>
      </Stack>
    </Box>
  );
}

export { ReviewSearchForm };
